import { getInfographUri } from 'utils/getInfographUri';

const UPLOAD_CSV_API = '/api/aiGeneration/upload_csv';

type UploadCSVResponseData = {
  fileName: string;
  signedUri?: string;
};

type UploadCSVResponseSuccess = {
  status: 'ok';
  data: UploadCSVResponseData;
};

type UploadCSVResponseFail = {
  status: 'fail';
  message: string;
};

type UploadCSVResponse = UploadCSVResponseSuccess | UploadCSVResponseFail;

/**
 * Up the csv string to our S3 bucket by calling our infograph api
 * @param {string} csvStr
 * @param {string} fileName expected file name to be store
 * @returns
 */
export const uploadCSV = (csvStr: string, fileType?: string) => {
  return new Promise<UploadCSVResponseData>((resolve, reject) => {
    if (!csvStr) {
      reject(new Error('The csv string to be uploaded is invalid'));
      return;
    }

    fetch(getInfographUri(UPLOAD_CSV_API), {
      method: 'POST',
      body: JSON.stringify({
        csvData: csvStr,
        fileType,
      }),
    })
      .then((httpResponse) => {
        if (!httpResponse.ok) {
          throw new Error('upload file fail');
        }

        return httpResponse.json();
      })
      .then((response: UploadCSVResponse) => {
        if (response.status === 'fail') {
          throw new Error(response.message);
        }

        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
